import { JURISDICTION_ID, JurisdictionId } from 'utils/jurisdiction'

// Temporary bridge, mirroring open-fe's @libs/shared/feature-flags: semantic
// feature flags derived from the jurisdiction in one place, to be replaced by
// the shared OS runtime configuration (OpenFeature) once that work lands.
export interface Features {
  /** Default UI language when the user has no stored preference */
  defaultLanguage: 'en' | 'zh'
  /** Whether external video providers (YouTube/Vimeo) are reachable in this jurisdiction */
  externalVideoAllowed: boolean
  /** Whether Google Fonts must be replaced with in-region mirrors */
  useCnFontMirrors: boolean
  /** Base URL for public static assets */
  publicAssetsBase: string
}

// Pure mapping with no environment reads — prefer this in tests.
export const resolveFeatures = (jurisdictionId: JurisdictionId): Features => ({
  defaultLanguage: jurisdictionId === 'CN' ? 'zh' : 'en',
  externalVideoAllowed: jurisdictionId !== 'CN',
  useCnFontMirrors: jurisdictionId === 'CN',
  publicAssetsBase: jurisdictionId === 'CN' ? 'https://public-assets.wppopen.cn' : 'https://public-assets.os.wpp.com',
})

// Resolved once from the current jurisdiction at module load — effectively constant.
export const FEATURES: Readonly<Features> = Object.freeze(resolveFeatures(JURISDICTION_ID))
